module.exports = __webpack_public_path__ + "static/media/THERMOR.1a0f5419.pdf";